import { BFilter, BFilterableField } from '../BFilterEditor/BFilterEditor.types';
import { BSortOptions } from './BTable.types'
import { parseDate } from "@/utils"; 

function escapeFilterValue(value: any): string {
    if (typeof value == "string") {
        return `"${value.replace(/"/g, '\\"')}"`;
    }
    return value;
}

export function serializeFilters(filters: BFilter[], fields: BFilterableField[]): string {
    if(!filters || !fields){
        return "";
    }

    return filters
        .map((it) => {
            let field = fields.find((it2) => it2.property == it.property);
            if (field?.editorComponent == "date-editor") {
                // special handling for date fields
                let value = null as Date | null; 
                if(typeof it.value == "string"){
                    value = parseDate(it.value,true);
                }
                else if(typeof it.value == "object"){
                    value = it.value as Date;
                }

                if (value) {
                    const upper = new Date(value);
                    upper.setUTCDate(upper.getUTCDate() + 1);
                    // greater than shouldn't include the current date
                    if (it.operation == "gt"){
                        value.setUTCDate(value.getUTCDate());
                    }
                    else if (it.operation == "le") {
                        return (`${it.property}:lt:${escapeFilterValue(dateCustomFormatting(upper))}`)
                    }
                    else if (it.operation == "eq") {
                        // special handling for date equals: translate to 24h interval                        
                        return (
                            `${it.property}:ge:${escapeFilterValue(dateCustomFormatting(value))},` +
                            `${it.property}:lt:${escapeFilterValue(dateCustomFormatting(upper))}`
                        );
                    }
                    
                    return `${it.property}:${it.operation}:${escapeFilterValue(dateCustomFormatting(value))}`;
                } else {
                    return "Unsupported date format or no value.";
                }
            }
            if (it.value === undefined) {
                return `${it.property}:${it.operation}`;
            }
            return `${it.property}:${it.operation}:${escapeFilterValue(it.value)}`;
        })
        .join(",");
}

function dateCustomFormatting(date: Date): string {
    const padStart = (value: number): string =>
        value.toString().padStart(2, '0');
    
    return `${date.getUTCFullYear()}-${padStart(date.getUTCMonth() + 1)}-${padStart(date.getUTCDate())}`;
}


export function serializeSortBy(sortBy: BSortOptions[]): string {
    return sortBy.map(it => `${it.isDescending ? "-" : "+"}${it.key}`).join(",");
}